import React from "react";
import Button from "@/components/common/Button";
import { MdOutlineNavigateNext } from "react-icons/md";
import { GrFormPrevious } from "react-icons/gr";
import { FaCheck } from "react-icons/fa6";
import { PiSealWarningFill } from "react-icons/pi";

interface TrainingLayoutProps {
  children?: React.ReactNode;
  step?: string | number;
  description?: string;
  handlePrev?: () => void;
  handleNext?: () => void;
  isFirstStep?: boolean;
  isLastStep?: boolean;
}

const TrainingLayout: React.FC<TrainingLayoutProps> = ({
  children,
  step,
}) => {
  return (
    <div className="w-full flex flex-col items-start justify-start gap-4 p-2 lg:p-8 bg-white rounded-xl group shadow-2xl shadow-slate-200">
      <h1 className="w-full border-b border-slate-200 py-2 lg:py-4">
        <span className="p-2 group-hover:bg-orange-600  group-hover:text-white">
          {step}
        </span>
      </h1>
      {children}
    </div>
  );
};

export default TrainingLayout;
